import { render, staticRenderFns } from "./InfoEmpresa.vue?vue&type=template&id=e8e47a80"
import script from "./InfoEmpresa.vue?vue&type=script&lang=js"
export * from "./InfoEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports